/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Action_Create_Document_ShareInputs */

const cs_action_create_document_share = /** @type {(inputs: Action_Create_Document_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit sdílení dokumentů`)
};

const en_action_create_document_share = /** @type {(inputs: Action_Create_Document_ShareInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create document share`)
};

/**
* | output |
* | --- |
* | "Create document share" |
*
* @param {Action_Create_Document_ShareInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const action_create_document_share = /** @type {((inputs?: Action_Create_Document_ShareInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Create_Document_ShareInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_action_create_document_share(inputs)
	return cs_action_create_document_share(inputs)
});